// eslint-disable-next-line import/no-extraneous-dependencies
import { FastAverageColor } from 'fast-average-color';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import STAR from '../../../../assets/images/star-icon.png';
import { Banner, Flex } from '../../../../components';
import { useHotelState } from '../../../../state';
import { Image } from '../../../AboutHotel/AboutHotel.styled';
import {
  Addres,
  HomeCoverWrapper,
  HotelLogoContainer,
  HotelLogoWrapper,
  HotelName,
} from './Hotel.styled';

export const Hotel: FC = () => {
  const { hotelData } = useHotelState();
  const navigate = useNavigate();

  const imgRef = useRef<HTMLImageElement | null>(null);
  const [dominantColor, setDominantColor] = useState<string>('#fff');

  useEffect(() => {
    const img = imgRef.current;
    if (img && hotelData.brand_url) {
      const fac = new FastAverageColor();

      fac.getColorAsync(img, {
        left: 0,
        top: 0,
        width: 10,
        height: 10,
      })
        .then((color : any) => {
          const [r, g, b, a] = color.value;

          if (a === 0 || (r === 0 && g === 0 && b === 0)) {
            setDominantColor('#ffffff');
          } else {
            setDominantColor(color.rgb);
          }
        })
        .catch((error: Error) => {
          console.error('Color extraction failed:', error);
        });
    }
  }, [hotelData.brand_url]);

  return (
    <HomeCoverWrapper>
      <Flex direction="column" gap="8px">
        {hotelData.cover_photo && (
          <Banner
            image={hotelData.cover_photo}
            height="300px"
            action={() => navigate('/about-hotel')}
          />
        )}

        <HotelLogoWrapper>
          <HotelLogoContainer style={{ backgroundColor: dominantColor }}>
            <img
              ref={imgRef}
              src={hotelData.brand_url}
              alt={hotelData.name}
              style={{ width: '100px', height: 'auto', display: 'block' }}
              crossOrigin="anonymous"
            />
          </HotelLogoContainer>
          <Flex itemAlign="center" justifyContent="center" direction="column" gap="3px">
            <HotelName>{hotelData.name}</HotelName>
            <Addres>{hotelData.address.street}
              {' '}{hotelData.address.number}, {hotelData.address.postal_code} {hotelData.address.city_name}
            </Addres>
            <Flex direction="row" itemAlign="center" justifyContent="center" gap="3px" margin="10px 0">
              {Array.from({ length: hotelData.stars || 0 }).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Image key={index} src={STAR} style={{ width: '20px', height: '20px' }} alt="star" />
              ))}
            </Flex>
          </Flex>

        </HotelLogoWrapper>
      </Flex>
    </HomeCoverWrapper>
  );
};
